<template>
    <div id="bodyText" ref="wrapper">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: ['force-new-tab'],
        data() {
            return {
                //
            }
        },
        methods: {
            initializeVisitForm(element) {
                // Create the iframe element
                const iframe = document.createElement('iframe');

                let src = `/visit/widget/${element.dataset.visitForm}`;

                if (element.dataset.skipWelcomePage) {
                    src += '?skip_welcome_page=1';
                }

                iframe.src = src;
                iframe.style.width = '100%'; // Adjust width as needed
                iframe.style.border = 'none'; // Optional, remove iframe border
                iframe.setAttribute('loading', 'lazy'); // Optional, for performance

                // Append the iframe to the div
                element.replaceWith(iframe);

                // Listen for the iframe load event to adjust height
                iframe.addEventListener('load', () => {
                    try {
                        const iframeDocument = iframe.contentWindow.document;

                        // Resize initially after the iframe loads
                        const resizeIframe = () => {
                            const newHeight = iframeDocument.body.scrollHeight || iframeDocument.documentElement.scrollHeight;
                            iframe.style.height = newHeight + 'px';
                        };

                        // Set up ResizeObserver to monitor height changes
                        const observer = new ResizeObserver(resizeIframe);
                        observer.observe(iframeDocument.body);

                        // Run resize once to set initial height
                        resizeIframe();

                        iframeDocument.addEventListener('click', function (event) {
                            let target = event.target;

                            // Traverse up the DOM tree to check if an anchor (<a>) was clicked
                            while (target && target.tagName !== 'A') {
                                target = target.parentElement;
                            }

                            if (target && target.tagName === 'A') {
                                const href = target.getAttribute('href');

                                // Check if the link is pointing to the same domain
                                if (href && href.startsWith('/') || href.startsWith(window.location.origin)) {
                                    event.preventDefault(); // Prevent the default navigation in the iframe
                                    window.location.href = href; // Redirect the main window
                                }
                            }
                        });
                    } catch (error) {
                        console.error('Unable to access iframe content for resizing:', error);
                    }
                });
            }
        },
        mounted() {
            var self = this;
            jQuery('#bodyText a').each(function() {
                let $anchor = jQuery(this);

                if (self.forceNewTab || ($anchor.attr('href') && $anchor.attr('href').toLowerCase().includes('#newtab'))) {
                    jQuery(this).attr('target', '_blank');
                }
            });

            const visitForms = this.$refs.wrapper.querySelectorAll('div[data-visit-form]');

            visitForms.forEach((div) => {
              this.initializeVisitForm(div);
            })
        }
    }
</script>
